module.exports = __webpack_public_path__ + "img/ninety-nine-logo-white.993670d6.svg";